import InnyMascot from './InnyMascot';

export default function Loader({ label = 'Loading…' }) {
  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-2 text-ink2" role="status" aria-live="polite">
      <InnyMascot size={112} animated />
      {label && <p className="text-[14px]">{label}</p>}
    </div>
  );
}
